import { render, staticRenderFns } from "./dialogStorico.vue?vue&type=template&id=275bf736"
import script from "./dialogStorico.vue?vue&type=script&lang=js"
export * from "./dialogStorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports